import React from "react";
import Skeleton from "react-loading-skeleton";
import loadClasses from "./load.module.css";
function Load() {
    return (
        <div className={loadClasses["Table"]}>
            <table>
                <thead>
                    <tr>
                        <th>Resource </th>
                        <th>Topic Covered </th>
                        <th>Resource Type </th>
                        <th>Material </th>
                        <th>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    {Array(3)
                        .fill()
                        .map(() => (
                            <tr>
                                <td>
                                    <Skeleton height={"1rem"} />
                                </td>

                                <td>
                                    <Skeleton />
                                </td>
                                <td>
                                    <Skeleton />
                                </td>
                                <td>
                                    <Skeleton />
                                </td>
                                <td>
                                    <Skeleton />
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
}

export default Load;
